import CalculationItem from "@/models/CalculationItem";
import CalculationDetail from "@/models/CalculationDetail";
import Transportation from "@/models/Transportation";
import Assembly from "@/models/Assembly";
import IndividualItem from "@/models/IndividualItem";
import Measure from "@/models/Measure";
import Customer from "@/models/Customer";
import DeliveryAddress from "@/models/DeliveryAddress";

// constructor for Calculation object from database object

function Calculation(calc) {
  let calculationOrigin = calc;
  let item_list = [];
  let individual_item_list = []
  this.uid = calc.uid;
  this.name = calc.name;
  this.number = calc.number;
  this.pdfFile = calc.pdf_file;
  this.status = calc.status;
  this.proformaValue = calc.proforma_value === null ? 50 : calc.proforma_value;
  this.deliveryTime = calc.delivery_time === null ? 'do 3 týdnů' : calc.delivery_time;
  this.delegatedVat = calc.delegated_vat;
  this.vat = calc.vat;
  this.internalNote = calc.internal_note;
  this.detail = new CalculationDetail(calc.detail);
  this.customer = new Customer(calc.customer);
  this.deliveryAddress = calc.delivery_address ? new DeliveryAddress(calc.delivery_address) : null;
  if (calc.items.length > 0) {
    calc.items.forEach((currentValue) => {
      let item = new CalculationItem(currentValue);
      item_list.push(item);
    });
  }
  this.items = item_list;
  this.assembly = calc.assembly ? new Assembly(calc.assembly) : null;
  this.transportation = calc.transportation ? new Transportation(calc.transportation) : null;
  this.measure = calc.measure ? new Measure(calc.measure) : null;
  this.confirmed = calc.confirmed && typeof calc.confirmed === 'boolean' ? calc.confirmed : null;
  this.hasOrder = calc.has_order && typeof calc.has_order === 'boolean' ? calc.has_order : null;

  if (calc.individual_items && calc.individual_items.length > 0) {
    calc.individual_items.forEach((currentValue) => {
      let item = new IndividualItem(currentValue);
      individual_item_list.push(item);
    })
  }
  this.individualItems = individual_item_list;

  // added itemIdList in assembly and assembly
  if (this.assembly && this.items) {
    let itemList = [];
    this.items.forEach((item) => {
      if (item.calculationAssemblyId) {
        itemList.push(item.id)
      }
    })
    this.assembly.itemList = itemList
  }

  // added itemIdList in assembly and transportation
  if (this.transportation && this.items) {
    let itemList = [];
    this.items.forEach((item) => {
      if (item.calculationTransportationsId) {
        itemList.push(item.id)
      }
    })
    this.transportation.itemList = itemList
  }

  Object.defineProperty(this, 'calculationOrigin', {
    get: () => {
      return calculationOrigin
    }
  })
}

export default Calculation;